import { Component, OnInit } from '@angular/core';
import {ShowableFormGroup} from "../shared/ShowableFormGroup";
import {Phase, Project} from "../interfaces/project";
import {ProjectService} from "../shared/project.service";
import {Router} from "@angular/router";
import {FormArray, FormBuilder, FormGroup, ValidationErrors} from "@angular/forms";
import {DirectoryService} from "../shared/directory.service";
import {Industry} from "../interfaces/industry";
import {BSValidators} from "../shared/bsvalidators";
import {Globals} from "../shared/Globals";
import {ProjectRole} from "../interfaces/projectRole";
import {ClientService} from "../shared/client.service";
import {PopupDialogComponent} from "../dialogs/popup-dialog/popup-dialog.component";
import {ClientComponent} from "../clients/client.component";
import {Client} from "../interfaces/client";
import {NbDialogService, NbLayoutScrollService} from "@nebular/theme";
import {SubscribedComponent} from "../subscribed.component";
import {MemberAssignment} from "../interfaces/memberAssignment";

@Component({
    selector: 'bst-new-project',
    templateUrl: './new-project.component.html',
    styleUrls: ['./projects.component.scss'],
    standalone: false
})
export class NewProjectComponent extends SubscribedComponent{

  // Forms
  public forms: ShowableFormGroup[] = [];
  public projectroles: ProjectRole[];
  public submitting: boolean = false;
  public addnew = ($event: any) => {
    return new Promise((resolve, reject) => {
      const client = this.clientService.emptyClient;
      const sub = this.dialogService.open<PopupDialogComponent<ClientComponent>>(PopupDialogComponent, {
        closeOnBackdropClick: false,
        context:{
          comp: ClientComponent,
          componentContext: {
            client: client,
            editing: true,
            couldArchive: false
          }
        }
      }).onClose.subscribe((o: ClientComponent) => {
        let item: Client = null;
        if(o.client && o.client.id) {
          item = o.client;
        }
        if(sub){
          sub.unsubscribe();
        }
        return resolve(item);
      });
    });
  };

  constructor(private projectService: ProjectService,
              private router: Router,
              private fb: FormBuilder,
              public clientService: ClientService,
              private dialogService: NbDialogService,
              public scroll: NbLayoutScrollService,
              private directoryService: DirectoryService) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.bootstrap();
  }

  private async bootstrap(){

    this.projectroles = await this.directoryService.getProjectRoles().catch(() => []);

    this.forms.push(new ShowableFormGroup(this.fb.group({
      name: [null, [BSValidators.required, BSValidators.maxLength(100)]],
      description: [null, [BSValidators.maxLength(30000)]],
      color: [Globals.getRandomColor(), [BSValidators.required]],
      status: [1, [BSValidators.required]],
      for_Client_id: [null, [BSValidators.required]]
      // company: [null, [BSValidators.required, BSValidators.maxLength(100)]]
    })));

    this.forms.push(new ShowableFormGroup(this.fb.group({
      dates: [null, [BSValidators.required, BSValidators.dateRange()]],
      // duedate: [null, []]
    })));

    this.forms.push(new ShowableFormGroup(this.fb.group({
      industry: [null, [BSValidators.minElements(1)]]
    })));

    this.forms.push(new ShowableFormGroup(this.fb.group({
        skills: [null, []]
    })));

    this.forms.push(new ShowableFormGroup(this.fb.group({
        developments: [null, []]
    })));

    this.forms.push(new ShowableFormGroup(this.fb.group({
        certifications: [null, []]
    })));

    const fresh: Phase[] = [
      {
        id: -1,
        name: 'Phase 1',
        description: null,
        Project_id: null,
        members: []
      }
    ]
    this.forms.push(new ShowableFormGroup(this.fb.group({
      assignments: [fresh, []]
    })));
  }

  submit(){
    // Prevent double submission
    if (this.submitting) {
      return;
    }
    this.submitting = true;

    // Save the form
    let newproject:any = {};
    this.forms.forEach((o) => {
      newproject = {...newproject, ...o.form.value};
    });

    // clean up
    if(newproject.seniority){
      newproject.seniority = newproject.seniority.filter((o) => {
        return o.capacity;
      });
    }

    if(newproject.industry){
      newproject.industry = newproject.industry.map((o: Industry) => o.id);
    }

    for (const key of ['skills', 'developments', 'certifications']) {
        if (newproject[key]) {
            newproject[key] = newproject[key]
                .map((o: { id: number }) => o.id)
                .filter((id: number) => id != null);
        }
    }

    if(newproject.assignments){
      newproject.members = {assignments: [], phases: []};
      const phases = newproject.assignments;
      if(phases){
        newproject.members.phases = phases.map((p: Phase) => {
          newproject.members.assignments = newproject.members.assignments.concat(p.members.map((o: MemberAssignment) => {
            return {
              id: o.id,
              User_id: o.user?.id,
              Phase_id: o.Phase_id || p.id,
              start_on: Globals.toISODate(o.start_on),
              end_on: Globals.toISODate(o.end_on),
              dedication: o.dedication,
              cost: o.cost,
              offered: o.offered,
              status: o.status,
              description: o.description,
              ProjectRole_id: o.project_role ? o.project_role.id : (o.projectRole_id ? o.projectRole_id : null)
            };
          }));

          return {
            id: p.id,
            Project_id: -1,
            name: p.name,
            description: p.description
          }
        });
      }
    }
    else{
      newproject.members = [];
    }
    delete newproject.assignments;

    if(newproject.dates){
      newproject.dates.start = Globals.toISODate(newproject.dates.start);
      newproject.dates.end = Globals.toISODate(newproject.dates.end);
    }
    // if(newproject.duedate){
    //   newproject.duedate = Globals.toISODate(newproject.duedate);
    // }

    console.log(newproject);
    return this.projectService.addProject(<Project>newproject).then((project: Project) => {
      this.router.navigate(['projects/' + project.id]);
    }).catch((error) => {
      this.submitting = false;
      throw error;
    });
  }

  public get range(){
    return (this.forms && this.forms[1] && this.forms[1].form.get('dates')) ? <{start: Date, end:Date}>(this.forms[1].form.get('dates').value) : {start: null, end:null};
  }
}
